import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = `${(process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '')}/api`;

/**
 * Ist das aktive Projekt eine Person? Dann heißt die „Brand DNA“ in der Oberfläche „Personal DNA“.
 * Fällt bei Fehlern auf „Unternehmen“ zurück (alte Bezeichnung).
 */
export default function useActiveProjectType() {
  const { getAuthHeader, activeProjectId } = useAuth();
  const [isPerson, setIsPerson] = useState(false);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/projects/active`, { headers: getAuthHeader() })
      .then(({ data }) => { if (alive) setIsPerson(data?.project?.project_type === 'person'); })
      .catch(() => { if (alive) setIsPerson(false); });
    return () => { alive = false; };
  }, [activeProjectId]); // eslint-disable-line react-hooks/exhaustive-deps

  return { isPerson, dnaName: isPerson ? 'Personal DNA' : 'Brand DNA' };
}
